module.exports = __webpack_public_path__ + "img/qq.ce25c5c0.svg";